<template lang="html">
  <div class="timeline-content timeline-project">
    <h4 class="row between">
      <span>{{entry.title}}</span>
    </h4>
    <span class="fade small" style="font-weight: 300;">&lt;Prosjekt&gt;</span>
    <p>{{entry.content}}</p>
    <div class="row between">
      <a class="btn btn-primary-light" :href="entry.link" target="_blank" v-if="entry.link">
        <div>Besøk</div>
        <i class="fa fa-angle-right"></i>
      </a>

      <button class="btn btn-primary-light" v-if="entry.images && entry.images.length" @click="$emit('imageslider', entry.images)">
        <div>Vis</div>
        <i class="fa fa-angle-right"></i>
      </button>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/base/_colors";

.timeline-project {
  background: linear-gradient(
    -45deg,
    lighten($primary, 5%),
    darken($primary, 15%)
  );
  color: white;
}
</style>
